import { render, staticRenderFns } from "./collectionFeeConfig.vue?vue&type=template&id=6d817f82&"
import script from "./collectionFeeConfig.vue?vue&type=script&lang=js&"
export * from "./collectionFeeConfig.vue?vue&type=script&lang=js&"
import style0 from "./collectionFeeConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports